<template lang="pug">
    v-card
      //- v-card-title
        | Actualizar tienda
        v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
      v-card-text.body-1.text-center.pa-0
        v-row
          v-col(cols="12" md="12")
            v-form
              v-container(pa-0='')
                  v-dialog( persistent  :value='createCategoryDialog'  max-width='500px'   transition="dialog-bottom-transition")
                      div(style ='position:relative; height: 100%;')
                        create-category( @close="createCategoryDialog=false")
                  formStepper.mt-3(:model ='model', :field='field' :onSave='updateItem' :context ='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
</template>
<script>

  import Stepper from '../../components/custom/steppers/ShopStepper'
  import CreateCategory from '@/views/custom/CreateCategory'
  export default {

    components: {
      formStepper: Stepper,
      CreateCategory: CreateCategory,
    },
    props: {
      model: Object,
    },
    data: () => ({
      currentContext: 'shops',
      createCategoryDialog: false,
    }),
    computed: {
      field () {
        return {
          types: [{ name: 'Productos', value: 'products' }, { name: 'Servicios', value: 'services' }],
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
    },
    methods: {

      updateItem () {
        // A post entry.
        const vm = this
        const itemData = vm.model
        // this.$store.commit('setLoading', true);
        this.$forceUpdate()
        vm.$store.commit('shops/SET_LOADING', true)
        setTimeout(function () {
          // console.log(this.currentContext, itemData)
          this.$store.dispatch('shops/updateItem', itemData).then(() => {
            vm.$store.commit('shops/SET_LOADING', false)
            vm.onSuccess()
            itemData.categories.forEach(element => {
              if (element.preset) {
                vm.$store.dispatch('categories/updateItem', element)
              }
            })
          })
        }.bind(this), 1000)
      },
      onSuccess () {
        // this.$router.push({name: 'PropertyList'});
        this.$emit('saveVirtual')
        this.$emit('close')
      },
      cancel () {
        this.$emit('close')
      },
      // setImage (image) {
      //     this.model.imagen = image;
      //
      // }
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }
</style>
